//
// Site JS
//

// Cookie Consent first
import CookieConsentConfig from './components/cookie-consent-config';
new CookieConsentConfig();

// Vendor
import sal from 'sal.js'

// Modules
import NavMenuDesktop from './components/nav-menu-desktop';
import NavMenuMobile from './components/nav-menu-mobile';
import Homepage from './components/homepage';
import VideoModal from './components/video-modal';
import JobCarousel from './components/job-carousel';
import ImageCarousel from './components/image-carousel';
import SiteSearch from "./components/site-search";

// Check if JS is enabled in browser, if so the `no-js` class is removed from <body>
document.body.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', function () {

    // Remove .preload class
    document.body.classList.remove('preload');

    // Initialize Sal
    sal({
      threshold: 0.15
    });

    // Update Sal for pages with AJAX content (Sprig)
    window.addEventListener('htmx:afterSwap', function (event) {
      const scrollAnimations = sal();
      scrollAnimations.update();
    });

    // Initialize Modules
    new NavMenuDesktop();
    new NavMenuMobile();
    new Homepage();
    new SiteSearch();
    new VideoModal();
    new JobCarousel();
    new ImageCarousel();

}, false);